module.exports = __webpack_public_path__ + "static/media/DC_O_Fashion_Necchi_Blue-Orange.ed138f75.png";